import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2fe24a72"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "full-screen-body"
};
var _hoisted_2 = {
  class: "tips-box"
};
var _hoisted_3 = {
  class: "screen-guide-body"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "guide-tips"
  }, "请授权整个屏幕的分享权限", -1);
});
var _hoisted_5 = {
  class: "guide-box"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "guide-tips"
  }, "window系统电脑权限设置示例：", -1);
});
var _hoisted_7 = {
  class: "guide-box"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "guide-tips"
  }, "mac系统电脑权限设置示例：", -1);
});
var _hoisted_9 = {
  class: "guide-box"
};
var _hoisted_10 = {
  class: "action-area"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "检测到屏幕分享未开启", -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "请开启屏幕分享", -1);
});
var _hoisted_13 = /*#__PURE__*/_createTextVNode(" 分享屏幕 ");
import { TrtcService } from '@/services/exam/trtc.service';
import { useService } from '@kaokei/use-vue-service';
import WinGuideImg from '@/assets/image/envCheck/scree-share-win.png';
import MacGuideImg from '@/assets/image/envCheck/screen-share-mac.png';
import ShareScreen from '@/assets/image/envCheck/share-screen.jpg';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var trtcService = useService(TrtcService);
    var onStartScreenShare = function () {
      trtcService.eventTrack({
        eventName: 'startScreenShare'
      });
      trtcService.initScreenShare();
    };
    return function (_ctx, _cache) {
      var _component_a_image = _resolveComponent("a-image");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(trtcService).showScreenShareTips,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(trtcService).showScreenShareTips = $event;
        }),
        closable: false,
        "destroy-on-close": true,
        "mask-closable": false,
        keyboard: false,
        title: "屏幕分享引导",
        footer: null,
        centered: "",
        width: "100%",
        wrapClassName: "full-modal"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_image, {
            width: 320,
            src: _unref(ShareScreen),
            alt: ""
          }, null, 8, ["src"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_image, {
            width: 750,
            src: _unref(WinGuideImg),
            alt: ""
          }, null, 8, ["src"])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_image, {
            width: 750,
            src: _unref(MacGuideImg),
            alt: ""
          }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _hoisted_12, _createVNode(_component_a_button, {
            class: "btn",
            type: "primary",
            onClick: onStartScreenShare
          }, {
            default: _withCtx(function () {
              return [_hoisted_13];
            }),
            _: 1
          })])])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
});